import { createTheme } from '@material-ui/core/styles';
import {
    deepOrange,
    lightBlue,
} from '@material-ui/core/colors'

const theme = createTheme({
    palette: {
        primary: {
            // lightBlue[800]: contraste 5.1:1 con texto blanco (lightBlue[400] daba 2.3:1)
            main: lightBlue[800],
            light: lightBlue[400],
        },
        secondary: {
            main: deepOrange['A400']
        }
    }
});

export default theme
